import React from 'react'
import "./style.css";
function Faqs(props) {

  // const [faq_values,set_faq] = useState(initial_faqs);
  // function manage_faqs(open_id)
  // {
  //   if(open_id==null) return "";
  //   console.log(open_id);    
  //   const new_faq =  faq_values.filter((el)=>{
  //                   if(el.id=== open_id)
  //                   {
  //                     el.active=!el.active;
  //                   }
  //                   else{
  //                     el.active=false;
  
  //                   }
  //                   return el;
  
  //                 })
  //                 console.log(new_faq);
  //                 set_faq(new_faq);
 
  // }






  return (
    <dl key={props.id} id={props.id} className={props.active===true?"active_faq faq_block":"faq_block"}>

      <dt onClick={(e)=>props.event_function(props.id)}    className='faq_title' ><i className={props.active===true?"fas fa-minus":"fas fa-plus"}></i> 
      <p>{props.query}</p>
      </dt>

      <dd className='faq_details'>
        <p>{props.ans}</p>
        </dd>
    </dl>
  )
}

export default Faqs